export default __webpack_public_path__ + "static/media/cerrarIconosbarra-01.7cb05592.png";